<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog" :click-to-close="false">
		<form class="modal-content" role="form" @submit.prevent="onEdit(close)">
			<div class="modal-header py-2">
				<h1 class="modal-title fs-5">{{$t('header.discipline-edit')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="text-center" v-if="loading">
					<loading-spinner
						:overlay="loading"
						:text="$t('text.loading-data')"
					></loading-spinner>
				</div>
				<div v-else>
					<div class="mb-3">
						<label for="input-name" class="form-label">{{$t('text.name')}}:</label>
						<input id="input-name" ref="name" type="text" :placeholder="$t('placeholder.discipline-name')" class="form-control" v-model="name" required />
					</div>
					<div>
						<label for="select-lang" class="form-label">{{$t('text.lang')}}:</label>
						<select id="select-lang" class="form-select" v-model="lang" required>
							<option :value="lang.key" v-for="lang in appModel.examLangs" :key="lang.key">{{lang.name}}</option>
						</select>
					</div>
				</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="submit" class="btn btn-primary" :disabled="loading">{{$t('btn.save-changes')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</form>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
//import autosize from 'autosize';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		name: '',
		lang: 'ru',
		
		error: '',
		loading: false,
	}),
	methods: {
		async onEdit(close){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doEditDiscipline(this.$vfm.modals[0].params._value.discipline.id, {
				name: this.name.trim(),
				discipline_lang: this.lang,
			});
			if(ret.success){
				this.$emit('edit', close);
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
	},
	async mounted(){
		this.name = this.$vfm.modals[0].params._value.discipline.name;
		this.lang = this.$vfm.modals[0].params._value.discipline.lang;
		
		setTimeout(() => {
			this.$refs.name.focus();
		}, 300);
	},
	components: {
		LoadingSpinner,
	},
}
</script>